import { Component, OnInit, OnDestroy } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { StorageService } from '../../../shared/security/StorageService';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { TransferEmployerCloseOfficeService } from '../transfer-employer-close-office.service';
import { OfficeSelectableListModel } from '../../../model/officeSelectableListModel';
import * as $ from 'jquery';

@Component({
  selector: 'app-start-transfer-employer',
  templateUrl: './start-transfer-employer.component.html',
  styleUrls: ['./start-transfer-employer.component.css']
})
export class StartTransferEmployerComponent implements OnInit , OnDestroy{

  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel;

  title :string ="Sever/Transfer Employees, Close Office";

  constructor(private startFunctionService: StartFunctionService,private transferEmployerCloseOfficeService:TransferEmployerCloseOfficeService,private currentPageWatcher: CurrentPageWatcherService,
    private storage: StorageService,private router:Router,
    private spinner: SpinnerService) { 
    this.startFunction = this.storage.getStartFunctionData();
    if(this.startFunction!=null && this.startFunction!=undefined && this.startFunction.Workflow!=null){
    this.workflow = this.startFunction.Workflow;
    this.title= this.workflow.WorkflowDisplayName;
  }



  }

  ngOnInit() {
    this.currentPageWatcher.pageChanged().emit(this.title);
  }

  startWorkFlow(){
    this.router.navigate(['/searchEmployees']).then(() => {
     
      this.startFunctionService.getNotifyStepInProgress().emit(true);
 

    });
  }

  goBackHome(){
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/start-transfer-employer/start-transfer-employer.component.ts